import React from 'react';
import { PermissionsControl } from 'src/components/enterprise/features/Employee/components/Form/controls/PermissionsControlWrapper/PermissionsControl';
import { usePermissionsControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/PermissionsControlWrapper/hooks/usePermissionsControlWrapper';

export function PermissionsControlWrapper(): JSX.Element {
  const { filterOptions, isPermissionsEditable } =
    usePermissionsControlWrapper();

  return (
    <PermissionsControl
      id="role"
      name="role"
      filterOptions={filterOptions}
      disabled={!isPermissionsEditable}
    />
  );
}
